import React, { Fragment, useState, useEffect } from 'react'
import Footer from '../component/Footer'
import Header from '../component/Header'

function Carrito() {

    const [carrito, getCarrito] = useState([])
    const [total, setTotal] = useState(0);

    const leerCarrito = async () => {
        var datosCarrito = await JSON.parse(localStorage.getItem("carrito"))
        getCarrito(datosCarrito)
        if (datosCarrito !== null) {
            calculatTotal(datosCarrito)
        }
    }

    const calculatTotal = (datosCarrito) => {

        let subtotal = datosCarrito.map(item => item.precio * item.cantidad);
        let totalcarrito = subtotal.reduce((acumulador, a) => acumulador + a, 0);
        setTotal(totalcarrito)

    }

    const eliminarProducto = (item) => {
        let carritoMenos = carrito.filter(itemcarrito =>
            itemcarrito.idproducto !== item.idproducto)
        getCarrito(carritoMenos)
        localStorage.setItem("carrito", JSON.stringify(carritoMenos));
        calculatTotal = (carritoMenos)
    }

    const mostrarTable = () => {
        return (
            <div className='table-responsive'>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th>nombre</th>
                            <th className='text-end'>precio</th>
                            <th className='text-end'>cantidad</th>
                            <th className='text-end'>subtotal</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            carrito.map(item =>
                                <tr className="table-active" key={item.idproducto}>
                                    <th scope="row">{item.idproducto}</th>
                                    <td>{item.nombre}</td>
                                    <td className='text-end'>
                                        <span className='fw-bold'>S/. </span>{parseFloat(item.precio).toFixed(2)}</td>
                                    <td className='text-end'>
                                        {item.cantidad}
                                    </td>
                                    <td className='text-end'>
                                        <span className='fw-bold'>S/. </span>{parseFloat(item.precio * item.cantidad).toFixed(2)}
                                    </td>
                                    <td><i className="fa-solid fa-trash-can text-danger"
                                        style={{ cursor: "pointer" }} onClick={() => eliminarProducto(item)}></i></td>
                                </tr>

                            )
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan="5" className='text-end'> <span className='fw-bold'>S/. </span>{total.toFixed(2)}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        )
    }

    const vaciarCarrito = () => {
        localStorage.removeItem("carrito")
        getCarrito([])
        setTotal(0)
        alert("Se elimino correctamente")
    }
    useEffect(() => {
        leerCarrito()
    }, [])

    return (
        <Fragment>
            <Header />

            <div className='col-8 m-auto mt-5'>
                <h3 className='fw-light letra__ mb-3'>Tu carrito de compra</h3>
                <div className='d-flex justify-content-end'>
                    <button className='btn btn-danger text-capitalize fw-bold'
                        onClick={vaciarCarrito}
                    >Vaciar carrito</button>
                </div>
                {
                    carrito === null ? "El carro esta vacio" :
                        mostrarTable()
                }

            </div>
            <Footer />
        </Fragment>
    )
}

export default Carrito